exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".connection-link-description[data-v-7b789af0]{margin-bottom:15px;color:#666;font-size:14px}.connection-link-container[data-v-7b789af0]{background-color:#f8f9fa;border:1px solid #e9ecef;border-radius:6px;padding:15px;margin-bottom:10px}.link-display[data-v-7b789af0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px}.link-text[data-v-7b789af0]{-webkit-box-flex:1;-ms-flex:1;flex:1;word-break:break-all;font-family:monospace;font-size:13px;color:#495057;background-color:#fff;padding:8px 12px;border:1px solid #dee2e6;border-radius:4px}.copy-link-btn[data-v-7b789af0]{-ms-flex-negative:0;flex-shrink:0;min-width:auto;white-space:nowrap}.copy-link-btn[data-v-7b789af0]:disabled{opacity:.6;cursor:not-allowed}.modal-footer[data-v-7b789af0]{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7b789af0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/pages/account/settings/modals/ImportNewAirbnbRentalsToGetLink.vue
// module id = 1141
// module chunks = 0